import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ProductCardProps } from '../types';
import { getRemainingCount } from '@/utils/common/product-card';
import { CardType } from '../types';

export default function RemainCount(props: Partial<ProductCardProps & CardType>) {
  const { data, cardType } = props;
  const { t } = useTranslation('common');

  const remainCount = getRemainingCount(data);

  return remainCount ? (
    <div data-testid="wid-product-card-remain-count" className="w-full enki-body-3xs-strong text-pricing-txt">
      <span className=" inline-block mb-1.5">
        {cardType === 'horizontal'
          ? t('remain_count', { remainCount: remainCount })
          : t('order_soon', { quantity: remainCount })}
      </span>
    </div>
  ) : null;
}
